import React, {PropTypes} from 'react';
import StandardModal from 'shared/StandardModal.jsx';

const SquadDeleteModal = ({
  visible,
  onCancelClick,
  onDeleteClick,
  error
}) => (
  <StandardModal
    title="Delete Squad"
    visible={visible}
    onCloseClick={onCancelClick}>
      <div>
        {error &&
          <div className="alert alert-danger">
            {error}
          </div>
        }
        <div>
          {`Are you sure you want to delete?`}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
            <button
              type="button"
              className="btn btn-link"
              onClick={() => onCancelClick()}
            >{'No'}</button>
            <button
              type="button"
              className="btn btn-danger btn-lg"
              onClick={() => onDeleteClick()}
              disabled={error}
            >{`Yes`}</button>
        </div>
      </div>
    </StandardModal>
);

SquadDeleteModal.propTypes = {
  title: PropTypes.string,
  visible: PropTypes.bool,
  onCancelClick: PropTypes.func,
  onDeleteClickClick: PropTypes.func,
  error: PropTypes.string
};

export default SquadDeleteModal;



// WEBPACK FOOTER //
// ./src/features/tournament/squads/SquadDeleteModal.jsx